import React, { useState, useCallback, useEffect, use } from "react";
import { GoogleMap, MarkerF, InfoWindowF, useLoadScript } from "@react-google-maps/api";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Link } from "react-router-dom";


const mapContainerStyle = {
    width: "100%",
    height: "700px",
};

const center = {
    lat: 47.5163008,
    lng: 8.6445932,
};

const grayStyles = [
    { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#686868" }] },
    { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
    { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
    { featureType: "water", elementType: "all", stylers: [{ color: "#b7e4f4" }, { visibility: "on" }] }
];

const LocalMapComponent = ({ locationData, localAddress = false, markerColor = "orange" }) => {

    const [isLoading, setIsLoading] = useState(false);



    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: "AIzaSyApQjBO96fzVzx23FBn8_62gGIfpd0ijrY",
        libraries: ["places"],
    });

    const [activeMarker, setActiveMarker] = useState(null); // Track the active marker
    const [icon, setIcon] = useState(null);

    // const locations = [
    //     {
    //         name: "MedZentrum Pfungen",
    //         lat: 47.5163008,
    //         lng: 8.6445932,
    //         address: "Riedäckerstrasse 5, CH-8422 Pfungen",
    //         email: "apotheke@medzentrum.ch",
    //     }, 
    //     {
    //         name: "MedZentrum Pfungen 2",
    //         lat: 52.5163008,
    //         lng: 10.6445932,
    //         address: "Riedäckerstrasse 5, CH-8422 Pfungen",
    //         email: "apotheke@medzentrum.ch",
    //     }, 

    // ];

    const locations = locationData
        ?.map((item) => {

            // 👉 location
            const latitude = item?.Standort?.latitude;
            const longitude = item?.Standort?.longitude;

            // skip invalid coords
            if (!latitude || !longitude) return null;

            console.log("Processing item for map:", item?.Standort);

            return {
                // id: item?.id,

                // lat: parseFloat(latitude),
                // lng: parseFloat(longitude),

                // image:
                //     item?.Bild?.url
                //         ? `https://backend.bgzurlinden.ch${item?.Bild?.url}`
                //         : null,

                // address:
                //     item?.Titel || "No title",

                // description:
                //     item?.Standort?.Text || "No description",

                // slug: item?.slug || null,

                // pageName: item?.pageName || "",

                id: item?.id,

                lat: parseFloat(latitude),

                lng: parseFloat(longitude),

                image:
                    item
                        ?.Beitrags_Miniaturbild
                        ?.url
                        ? `https://backend.bgzurlinden.ch${item?.Beitrags_Miniaturbild?.url}`
                        : null,

                address:
                    item?.Page_Titel ||
                    "No title",

                description:
                    item?.Standort?.Text || "",

                Titel_Text: item?.Standort?.Titel_Text || "",

                pageTemplate:
                    item?.Page_Template || null,

                slug:
                    item?.slug || null,
            };
        })
        ?.filter(Boolean);

    // useEffect(() => {
    //     console.log("Locations for Map:", locations);
    // }, [locations]);

    // Load the custom icon once the Google Maps API is loaded
    useEffect(() => {
        if (isLoaded && window.google) {
            setIcon({
                url: markerColor === "blue" ? "https://backend.bgzurlinden.ch/uploads/mappin_blue_6e5bf52ffe.svg" : "https://backend.bgzurlinden.ch/uploads/Group_1597880547_824772d26d.svg",
            });
        }
    }, [isLoaded]);

    //   useEffect(() => {
    //     let btn = document.getElementsByClassName('gm-style-iw.gm-style-iw-c');
    //     if(btn){
    //         btn[1].style.display = 'none';
    //     }
    //   }, [])

    useEffect(() => {
        const hideElement = () => {
            const element = document.querySelector('[aria-labelledby="E4E5F0F4-068C-44B0-B3E5-6004C4C2BF26"]');
            if (element) {
                element.style.display = "none";
            }
        };

        const interval = setInterval(hideElement, 500); // Check every 500ms

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);


    // const onMapLoad = useCallback((map) => {
    //     console.log("Map Loaded:", map);
    // }, []);

    const onMapLoad = useCallback((map) => {
        if (!locations?.length) return;

        // Single location
        if (locations.length === 1) {
            map.setCenter({
                lat: locations[0].lat,
                lng: locations[0].lng,
            });

            map.setZoom(16);
            return;
        }

        const bounds = new window.google.maps.LatLngBounds();

        locations.forEach((loc) => {
            bounds.extend({
                lat: loc.lat,
                lng: loc.lng,
            });
        });

        map.fitBounds(bounds);
    }, [locations]);

    if (loadError) return <p>Error loading maps</p>;
    if (!isLoaded) return <p>Loading maps...</p>;

    return (
        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={10}
            // center={center}
            options={{ styles: grayStyles, disableDefaultUI: true }}
            onLoad={onMapLoad}
        >
            {locations?.map((location, index) => (
                <MarkerF
                    key={index}
                    position={{ lat: location.lat, lng: location.lng }}
                    icon={icon} // Use the custom icon
                    // onMouseOver={() => setActiveMarker(index)} // Set the active marker on click
                    // onMouseOut={() => setActiveMarker(null)}
                    onClick={() =>
                        setActiveMarker((prev) => (prev === index ? null : index))
                    }
                >
                    {/* Render InfoWindow only for the active marker */}
                    {activeMarker === index && markerColor === "orange" && false && (
                        <InfoWindowF
                            position={{ lat: location.lat, lng: location.lng }}
                            onCloseClick={() => setActiveMarker(null)}
                        >
                            {/* <div>
                                {location.image && <img style={{ width: '100%', height: '180px', objectFit: 'cover' }} src={location.image} alt="" />}
                                {location.address && <p style={{ fontSize: localAddress ? '20px' : '16px', marginBottom: localAddress ? '0.5rem' : 0, color: localAddress ? 'var(--orange)' : "#000", fontFamily: 'var(--manrope)' }}><strong>{location.address}</strong></p>}
                                {location.description && <div style={{ lineHeight: '1.7', fontFamily: 'var(--manrope)' }}>
                                    <p>{location?.description}</p>
                                </div>}
                            </div> */}
                            <div>
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                    {location.image && (
                                        <img
                                            className="mb-0"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                border: "3px solid #fff",
                                                marginLeft: "-3rem",
                                            }}
                                            src={
                                                location.image
                                            }
                                            alt=""
                                        />
                                    )}

                                    {location.address && (
                                        <p
                                            style={{
                                                fontSize:
                                                    localAddress
                                                        ? "20px"
                                                        : "17px",

                                                marginBottom:
                                                    "0.5rem",

                                                fontFamily:
                                                    "var(--manrope)",
                                            }}
                                        >
                                            <strong className={`address-text ${markerColor === "blue" ? "blue" : "orange"}-line`} style={{ color: markerColor === "blue" ? 'var(--blue)' : 'var(--orange)' }}>
                                                {
                                                    location.address
                                                }
                                            </strong>
                                            <br />
                                            <span style={{ fontSize: '13px', display: 'inline-block', lineHeight: '1.5', marginTop: '0.5rem' }}>
                                                {location?.description?.split("\n").map((line, index) => (
                                                    <React.Fragment key={index}>
                                                        {line}
                                                        <br />
                                                    </React.Fragment>
                                                ))}
                                            </span>
                                        </p>
                                    )}
                                </div>
                                {location?.Titel_Text?.length > 0 && <div className="d-flex justify-content-between map-content" style={{ gap: '1rem', marginTop: '0.5rem', borderTop: '1px solid #EFEFEF', paddingTop: '1rem' }}>
                                    {location?.Titel_Text?.map((item, idx) => (
                                        <div className="item">
                                            <p style={{ marginBottom: '0.5rem' }}><strong>{item?.Titel}</strong></p>
                                            <p>{item?.Text}</p>
                                        </div>
                                    ))}
                                </div>}
                            </div>
                        </InfoWindowF>
                    )}
                </MarkerF>
            ))}
        </GoogleMap>
    );
};

export default LocalMapComponent;